import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  }
};

const enhance = compose();

const UserTableHead = enhance(({ order, orderBy, onRequestSort }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell sortDirection={orderBy === 'menuId' ? order : false}>
          <TableSortLabel
            active={orderBy === 'menuId'}
            direction={order}
            onClick={() => {
              onRequestSort('menuId');
            }}
          >
            メニューID
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'menuName' ? order : false}>
          <TableSortLabel
            active={orderBy === 'menuName'}
            direction={order}
            onClick={() => {
              onRequestSort('menuName');
            }}
          >
            メニュー名
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'menuChildType' ? order : false}>
          <TableSortLabel
            active={orderBy === 'menuChildType'}
            direction={order}
            onClick={() => {
              onRequestSort('menuChildType');
            }}
          >
            種別
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'shopId' ? order : false}>
          <TableSortLabel
            active={orderBy === 'shopId'}
            direction={order}
            onClick={() => {
              onRequestSort('shopId');
            }}
          >
            店舗ID
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'shopName' ? order : false}>
          <TableSortLabel
            active={orderBy === 'shopName'}
            direction={order}
            onClick={() => {
              onRequestSort('shopName');
            }}
          >
            店舗名
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'groupId' ? order : false}>
          <TableSortLabel
            active={orderBy === 'groupId'}
            direction={order}
            onClick={() => {
              onRequestSort('groupId');
            }}
          >
            グループID
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'groupName' ? order : false}>
          <TableSortLabel
            active={orderBy === 'groupName'}
            direction={order}
            onClick={() => {
              onRequestSort('groupName');
            }}
          >
            運営会社名
          </TableSortLabel>
        </TableCell>
        <TableCell
          sortDirection={orderBy === 'excludedTaxPrice' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'excludedTaxPrice'}
            direction={order}
            onClick={() => {
              onRequestSort('excludedTaxPrice');
            }}
          >
            税抜価格
          </TableSortLabel>
        </TableCell>
        <TableCell
          sortDirection={orderBy === 'includedTaxPrice' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'includedTaxPrice'}
            direction={order}
            onClick={() => {
              onRequestSort('includedTaxPrice');
            }}
          >
            税込価格
          </TableSortLabel>
        </TableCell>
        <TableCell>無料メニュー設定状況</TableCell>
        <TableCell />
        <TableCell />
      </TableRow>
    </TableHead>
  );
});

export default withStyles(styles)(UserTableHead);
